import React, { useState } from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import Flex from '@wix/da-ds/pkg/Flex';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import MediaManager, { getMediaSourceFromGallectionType } from '../../../MediaPopup/MediaManager';
import { GallectionType } from '../../../types/gallection';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumFolderDataIcon from '../../../GallectionFolderDropdown/_partials/PremiumFolderDataIcon';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import FolderStats from '../../legos/FolderStats';
import s from './FolderCardFooter.scss';
const FolderCardFooter = ({ folder, className, isLocked, withPremiumShownNextToTitle, withPrice, oneLineDescription, showCountsWithoutCaptions, hideStats, children, isProfileOwner, profileOwnerUser, t })=>{
    var _folder_premiumFolderData;
    const gallery_thumb_premium_flow = useFlag('gallery_thumb_premium_flow');
    const { formattedDollarPrice } = normalizePremiumFolderData(folder.premiumFolderData);
    const [isMediaManagerShown, setShowMediaManager] = useState(false);
    const closeMediaManager = (e)=>{
        setShowMediaManager(false);
        e && e.preventDefault();
        e && e.stopPropagation();
    };
    const isPaid = ((_folder_premiumFolderData = folder.premiumFolderData) === null || _folder_premiumFolderData === void 0 ? void 0 : _folder_premiumFolderData.type) === 'paid';
    const withSubscribersCount = isPaid;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], oneLineDescription && s['one-line-description'], !hideStats && s['with-stats'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, withPremiumShownNextToTitle && /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
        size: IconSize.SMALL,
        className: s['premium-icon'],
        premiumFolderData: folder.premiumFolderData
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: s['folder-name'],
        title: folder.name
    }, folder.name), isLocked && /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('folderCard.locked'),
        usePortal: true
    }, /*#__PURE__*/ React.createElement(LockIcon, {
        className: s['lock-icon'],
        size: IconSize.SMALLER,
        condensed: true
    })), withPrice && isPaid && /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, formattedDollarPrice)), /*#__PURE__*/ React.createElement(Flex, null, !hideStats && /*#__PURE__*/ React.createElement(FolderStats, {
        folder: folder,
        withSubscribersCount: withSubscribersCount,
        showCountsWithoutCaptions: showCountsWithoutCaptions
    }), gallery_thumb_premium_flow && isProfileOwner && /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        items: [
            {
                label: t('folderCard.sell'),
                onClick: (e)=>{
                    setShowMediaManager(true);
                    e && e.preventDefault();
                    e && e.stopPropagation();
                }
            }
        ],
        onClick: (e)=>{
            e && e.preventDefault();
            e && e.stopPropagation();
        },
        className: s['ellipsis'],
        withButton: true
    }, /*#__PURE__*/ React.createElement(EllipsisIcon, {
        size: IconSize.MEDIUM
    })), gallery_thumb_premium_flow && isMediaManagerShown && /*#__PURE__*/ React.createElement(MediaManager, {
        initialMediaSource: getMediaSourceFromGallectionType(GallectionType.GALLERY),
        gruser: profileOwnerUser,
        gallectionFolder: folder,
        onDone: closeMediaManager,
        onClose: closeMediaManager
    }))), children);
};
export default withTranslation()(FolderCardFooter);
